import { Middleware } from 'redux';

import { budgetController } from '../../api';
import { UpdateArticleClient } from '../budgetActions';
import { SetArticleClientPayload, BudgetActionTypes } from '../budgetActions/types';
import { i18n } from 'i18n';
import { showErrorToast } from 'utils/toasts';

export const PersistArticleClient: Middleware = (storeApi) => (next) => async (action) => {
  if (
    action.type === BudgetActionTypes.SET_ARTICLE_CLIENT) {
    const result = next(action);

    const { article, client }: SetArticleClientPayload = action.payload;
    const put = async () => budgetController.SetInvoiceArticleClient(
      article.id,
      article.type,
      client,
    );

    try {
      await put();

      storeApi.dispatch(UpdateArticleClient({
        articleId: article.id,
        clientId: client,
      }));
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      showErrorToast(i18n.t(error.message));
    }
    return result;
  }

  return next(action);
};
